<template>
  <HeaderContent title="CheckIn Lists" />
  <ActionContent
    :cta="false"
    :filter-modal="false"
    @action="toggleModal"
    @showFilter="toggleFilterModal"
    v-model:start-date="startDate"
    v-model:end-date="endDate"
    v-model:search="search"
    @search-query="handleSearch"
  />

  <CheckInStatistics title="Check In Statistics" :data="statistics" />
  <PaymentForm
    :modal="modalPayment"
    :uuid="reservationUuid"
    @update:modal="modalPayment = $event"
    @paid="getAll"
  />
  <ExtrachargeForm
    :modal="modalExtraCharge"
    :uuid="reservationUuid"
    @update:modal="modalExtraCharge = $event"
    @addedExtraCharge="getAll"
  />
  <CheckInForm :modal="modal" @update:modal="modal = $event" />

  <ReservationInformation
    :modal="modalInformation"
    :reservationData="reservationData"
    @update:modal="modalInformation = $event"
  />

  <CheckInConfirm
    title="CheckIn Confirmation"
    :uuid="reservationUuid"
    :dataPriview="dataPriview"
    :data="checkin"
    :actionType="actionType"
    :modalConfirm="modalCheckIn"
    v-model="modalCheckIn"
    @confirmed="handleModalConfirmation"
  >
    <template #body>
      <div class="guest-info text-start" id="printArea">
        <!-- <div id="printArea">
          //informasi tamu 
          <div class="px-3 border-bottom">
            <p class="text-secondary fw-semibold mb-2">Guest Information</p>
            <ul class="guest">
              <li class="mb-1 d-flex gap-2">
                <span>ID/Passport</span>
                <span>:</span>
                <span class="fw-semibold">{{
                  checkin?.reservation?.guest?.identity_number ?? "-"
                }}</span>
              </li>
              <li class="mb-1 d-flex gap-2">
                <span>Name</span>
                <span>:</span>
                <span class="fw-semibold">{{
                  checkin.reservation?.guest?.fullname ?? "-"
                }}</span>
              </li>
              <li class="mb-1 d-flex gap-2">
                <span class="label">Contact</span>
                <span class="label">:</span>
                <span class="fw-semibold"
                  >0{{ checkin.reservation?.guest?.phone ?? "-" }}</span
                >
              </li>
              <li class="mb-1 d-flex gap-2">
                <span class="label">CheckIn</span>
                <span class="label">:</span>
                <span class="fw-semibold">{{
                  dateFormatter(checkin?.check_in_date) ?? "-"
                }}</span>
              </li>
              <li class="mb-1 d-flex gap-2">
                <span class="label">CheckOut</span>
                <span class="label">:</span>
                <span class="fw-semibold">{{
                  dateFormatter(checkin?.check_out_date) ?? "-"
                }}</span>
              </li>
              <li class="mb-1 d-flex gap-2">
                <span class="label"> Duration</span>
                <span class="label">:</span>
                <span class="fw-semibold">{{
                  countDays(checkin?.check_in_date, checkin?.check_out_date)
                }} night</span>
              </li>
            </ul>
          </div>

          //Detail Tagihan
          <div class="p-3 border-bottom">
            <p class="text-secondary fw-semibold mb-2">Billing Details</p>
            <ul class="billing">
              <li class="mb-1 d-flex gap-2">
                <span class="label">Room Type</span>
                <span class="label">:</span>
                <span class="fw-semibold">{{
                  checkin?.reservation?.room?.room_category?.name ?? "-"
                }}</span>
              </li>
              <li class="mb-1 d-flex gap-2">
                <span class="label">Room Number</span>
                <span class="label">:</span>
                <span class="fw-semibold">{{
                  checkin?.reservation?.room?.code ?? "-"
                }}</span>
              </li>
              <li class="mb-1 d-flex gap-2">
                <span class="label">Room Rate</span>
                <span class="label">:</span>
                <span class="fw-semibold">{{
                  // format lama
                  // formatIDR(
                  //   checkin?.reservation?.room?.room_category
                  //     ?.low_season_price ?? 0
                  // )
                  formatIDR(getRoomPrice(checkin))
                }}</span>
              </li>
              <li class="mb-1" style="list-style: none">
                <div class="d-flex gap-2 align-items-start">
                  <span class="label">Extra Charge</span>
                  <span class="label">:</span>
                  <div class="extra-charges">
                    <div
                      v-if="checkin?.reservation?.extracharge?.length === 0"
                      class="fw-semibold"
                    >
                      -
                    </div>
                    <div
                      v-for="(item, index) in checkin?.reservation
                        ?.extracharge ?? []"
                      :key="index"
                      class="extra-charge-item fw-semibold"
                    >
                      {{ item?.extra_charge?.name }} (x{{ item?.quantity }} | 
                      {{ formatIDR(item?.extra_charge?.price ?? 0) }})
                    </div>
                  </div>
                </div>
              </li>
              <li class="mb-1 d-flex gap-2">
                <span class="fw-semibold">Total Payment</span>
                <span class="fw-semibold label">:</span>
                <span class="fw-semibold">{{
                  formatIDR(totalPembayaran ?? 0)
                }}</span>
              </li>
              <li class="mb-1 d-flex gap-2">
                <span class="label">Payment Status</span>
                <span class="label">:</span>
                <span class="fw-semibold">{{
                  checkin?.reservation?.payment_status ?? "-"
                }}</span>
              </li>
              <li class="mb-1 d-flex gap-2">
                <span class="label">Pending Bill</span>
                <span class="label">:</span>
                <span class="fw-semibold">{{
                  formatIDR(sisaTagihan ?? 0)
                }}</span>
              </li>
              <li class="mb-1 d-flex gap-2">
                <span class="label">Total Payment</span>
                <span class="label">:</span>
                <span class="fw-semibold">{{
                  formatIDR(reservation?.grand_total ?? 0)
                }}</span>
              </li>
              <span class="label fst-italic">This reservation ready to Check In !</span>
            </ul>
          </div>
        </div> -->

        <!--  Kop & logo (print)  -->
        <div class="print-only text-center mb-4">
          <table class="w-full text-left border-collapse">
            <tbody>
              <tr class="border-b border-transparent">
                <td class="text-left pr-2">
                  <img
                    src="../../../public/img/hotel-deliriver.png"
                    alt="Hotel Logo"
                    style="width: 100px; height: auto"
                  />
                </td>
                <td class="text-left pr-2">
                  <h3 class="mt-2 mb-0">Deli River Hotel</h3>
                  <p class="mb-0">
                    Jl. Raya Namorambe No. 129, Medan, Indonesia
                  </p>
                  <p class="mb-0">
                    Phone: +62-61-7032967 | email: contact@hotel-deliriver.com
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
          <hr />
        </div>

        <h4 class="print-only text-align-center">CheckIn Invoice</h4>

        <!-- =====================  GUEST INFORMATION  ===================== -->
        <div class="px-3 border-bottom">
          <p class="text-secondary fw-semibold mb-2">Guest Information</p>

          <table class="w-full text-left border-collapse">
            <tbody>
              <tr class="border-b border-transparent">
                <td class="text-left pr-2">ID/Passport</td>
                <td class="text-left pr-2">:</td>
                <td class="text-left fw-semibold">
                  {{ checkin?.reservation?.guest?.identity_number ?? "-" }}
                </td>
              </tr>
              <tr class="border-b border-transparent">
                <td class="text-left pr-2">Name</td>
                <td class="text-left pr-2">:</td>
                <td class="text-left fw-semibold">
                  {{ checkin?.reservation?.guest?.fullname ?? "-" }}
                </td>
              </tr>
              <tr class="border-b border-transparent">
                <td class="text-left pr-2">Contact</td>
                <td class="text-left pr-2">:</td>
                <td class="text-left fw-semibold">
                  0{{ checkin?.reservation?.guest?.phone ?? "-" }}
                </td>
              </tr>
              <tr class="border-b border-transparent">
                <td class="text-left pr-2">Check In</td>
                <td class="text-left pr-2">:</td>
                <td class="text-left fw-semibold">
                  {{ dateFormatter(checkin?.check_in_date) ?? "-" }}
                </td>
              </tr>
              <tr class="border-b border-transparent">
                <td class="text-left pr-2">Check Out</td>
                <td class="text-left pr-2">:</td>
                <td class="text-left fw-semibold">
                  {{ dateFormatter(checkin?.check_out_date) ?? "-" }}
                </td>
              </tr>
              <tr class="border-b border-transparent">
                <td class="text-left pr-2">Duration</td>
                <td class="text-left pr-2">:</td>
                <td class="text-left fw-semibold">
                  {{
                    countDays(checkin?.check_in_date, checkin?.check_out_date)
                  }}
                  night
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <br />

        <!-- =====================  BILLING DETAILS  ===================== -->
        <div class="px-3">
          <p class="text-secondary fw-semibold mb-2">Billing Detail</p>

          <table class="w-full text-left border-collapse">
            <tbody>
              <tr class="border-b border-transparent">
                <td class="text-left pr-2">Room Type</td>
                <td class="text-left pr-2">:</td>
                <td class="text-left fw-semibold">
                  {{ checkin?.reservation?.room?.room_category?.name ?? "-" }}
                </td>
              </tr>

              <tr class="border-b border-transparent">
                <td class="text-left pr-2">Number</td>
                <td class="text-left pr-2">:</td>
                <td class="text-left fw-semibold">
                  {{ checkin?.reservation?.room?.code ?? "-" }}
                </td>
              </tr>

              <tr class="border-b border-transparent">
                <td class="text-left pr-2">Room Rate</td>
                <td class="text-left pr-2">:</td>
                <td class="text-left fw-semibold">
                  {{ formatIDR(getRoomPrice(checkin)) }}
                </td>
              </tr>

              <!-- Extra Charge -->
              <tr class="border-b border-transparent align-top">
                <td class="text-left pr-2">Extra Charge</td>
                <td class="text-left pr-2">:</td>
                <td class="text-left fw-semibold">
                  <div v-if="!checkin?.reservation?.extracharge?.length">-</div>
                  <div
                    v-else
                    v-for="(item, index) in checkin?.reservation?.extracharge"
                    :key="index"
                  >
                    {{ item?.extra_charge?.name }}
                    (x{{ item?.quantity }} |
                    {{ formatIDR(item?.extra_charge?.price ?? 0) }})
                  </div>
                </td>
              </tr>

              <!-- Payments (opsional: hapus jika tak dibutuhkan) -->
              <tr class="border-b border-transparent align-top">
                <td class="text-left pr-2">Payment</td>
                <td class="text-left pr-2">:</td>
                <td class="text-left fw-semibold">
                  <div v-if="!checkin?.reservation?.payment?.length">-</div>
                  <div
                    v-else
                    v-for="(item, index) in checkin?.reservation?.payment"
                    :key="index"
                  >
                    {{ item.payment_type }}
                    ( {{ formatIDR(item.amount ?? 0) }} at
                    {{ getFormattedDate(item.payment_date) }}
                    )
                  </div>
                </td>
              </tr>

              <tr class="border-b border-transparent">
                <td class="text-left pr-2">Pending Bill</td>
                <td class="text-left pr-2">:</td>
                <td class="text-left fw-semibold">
                  {{ formatIDR(sisaTagihan ?? 0) }}
                </td>
              </tr>

              <tr class="border-b border-transparent">
                <td class="text-left pr-2">Total</td>
                <td class="text-left pr-2">:</td>
                <td class="text-left fw-semibold">
                  {{ formatIDR(reservation?.grand_total ?? 0) }}
                </td>
              </tr>

              <tr class="border-b border-transparent">
                <td class="text-left pr-2">Status</td>
                <td class="text-left pr-2">:</td>
                <td class="text-left fw-semibold">
                  {{ checkin?.reservation?.payment_status ?? "-" }}
                </td>
              </tr>

              <!-- Pesan status (colspan agar teks panjang cukup satu baris) -->
              <tr class="border-b border-transparent">
                <td colspan="3" class="fst-italic text-secondary">
                  This reservation ready to Check In!
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </template>
  </CheckInConfirm>

  <CheckInFilter
    :modalFilter="modalFilter"
    @update:modalFilter="modalFilter = $event"
  />
  <CheckInDataTable
    :data="checkins"
    :header="headers"
    :currentPage="currentPage"
    :custom-actions="customActions"
  />
</template>

<script setup>
import { ref, inject, watch, onMounted, nextTick } from "vue";
import HeaderContent from "@/components/HeaderContent.vue";
import ActionContent from "@/components/ActionContent.vue";
import CheckInForm from "./CheckInForm.vue";
import CheckInFilter from "./CheckInFilter.vue";
import CheckInConfirm from "@/components/ModalDialog.vue";
import CheckInStatistics from "@/components/StatisticData.vue";
import CheckInDataTable from "@/components/DataTable.vue";
import PaymentForm from "@/components/Payment/PaymentForm.vue";
import ReservationInformation from "@/components/Reservation/ReservationInformation.vue";
import iconAlready from "../../../public/icons/assessment.svg";
import iconIncoming from "../../../public/icons/to-do.svg";
import ExtrachargeForm from "@/components/Extracharge/ExtrachargeForm.vue";
import { formatIDR } from "@/utils/currency";
import { dateFormatter } from "@/utils/dateFormatter";
import { countDays } from "@/utils/dateCalculation";
//import { useRoomPrice } from "@/composable/useRoomPrice";
import { getFormattedDate } from "@/composable/getDateTimeFormatter";

const repositories = inject("repositories");
const checkinRepository = repositories?.checkin;

const modal = ref(false);
const modalPayment = ref(false);
const modalExtraCharge = ref(false);
const modalCheckIn = ref(false);
const modalInformation = ref(false);
const modalFilter = ref(false);

const actionType = ref("checkin");
const reservationUuid = ref(null);
const reservationData = ref([]);
const checkin = ref({});

const startDate = ref(formatDate(new Date()));
const endDate = ref(formatDate(new Date()));
const search = ref("");
const filterStatus = ref({ status: null });

const statistics = ref([]);
const checkins = ref([]);

const headers = ref([
  { key: "reservation.number", label: "Reservation No", sortable: true },
  { key: "room_category", label: "Type", sortable: true },
  { key: "reservation.room.code", label: "Number", sortable: true },
  {
    key: "status_reservation",
    label: "Status",
    sortable: false,
  },
  { key: "reservation.guest.fullname", label: "Guest Name", sortable: true },
  { key: "check_in_date", label: "CheckIn at", sortable: true, 
    formatter: (value) => getFormattedDate(value) },
  { key: "check_out_date", label: "CheckOut at", sortable: true, 
    formatter: (value) => getFormattedDate(value) },
  { key: "day_left", label: "Total Night", sortable: true },
  {
    key: "reservation.payment_status",
    label: "Payment Status",
    sortable: true,
  },
  {
    key: "reservation.pre_payment",
    label: "Prepayment",
    sortable: true,
  },
  { key: "reservation.grand_total", label: "Total Bill", sortable: true },
  { key: "action", label: "Actions" },
]);

const customActions = ref([
  {
    label: "Add ExtraCharge",
    variant: "warning",
    icon: "fas fa-bolt",
    action: (item) => {
      reservationUuid.value = item.reservation_uuid;
      modalExtraCharge.value = true;
    },
  },
  {
    label: "Payment",
    variant: "primary",
    icon: "fas fa-money-bill-wave-alt",
    disabled: (item) =>
      item.reservation.is_paid ||
      item.reservation.payment_status === "Full Payment",
    action: (item) => {
      //console.log("hasillll", item);
      reservationUuid.value = item.reservation_uuid;
      modalPayment.value = true;
    },
  },
  {
    label: "Check In",
    variant: "success",
    icon: "fas fa-calendar-check",
    disabled: (item) =>
      !item.reservation.is_paid ||
      item.reservation.payment_status === "DP" ||
      item.check_in_date !== formatDate(new Date()),
    action: showConfirmModal,
  },
]);

function formatDate(date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
    2,
    "0"
  )}-${String(date.getDate()).padStart(2, "0")}`;
}

function getRoomPrice(checkin) {
  const start = new Date(checkin?.reservation?.start);
  const end = new Date(checkin?.reservation?.end);

  const isHighSeason = start.getMonth() === 5 || end.getMonth() === 5; // bulan Juni

  const category = checkin?.reservation?.room?.room_category;

  return isHighSeason
    ? category?.high_season_price ?? 0
    : category?.low_season_price ?? 0;
}

async function getAll(
  start = null,
  end = null,
  status = null,
  searchQuery = ""
) {
  const params = {};
  if (start) params.start = start;
  if (end) params.end = end;
  if (status && status !== "All") params.status = status;
  if (searchQuery) params.search = searchQuery;

  const res = await checkinRepository.getListCheckin(params);

  checkins.value = res.data.data;
  const checkinStatistics = res.data.statistics;

  statistics.value = [
    {
      label: "Total",
      key: "Already Check-In",
      value: checkinStatistics.in_house,
      color: "success",
      icon: iconAlready,
    },
    {
      label: "Total",
      key: "Incoming Check-In",
      value: checkinStatistics.incoming,
      color: "warning",
      icon: iconIncoming,
    },
  ];
}

function showConfirmModal(item) {
  reservationUuid.value = item.reservation_uuid;
  checkin.value = item;
  modalCheckIn.value = true;
}

async function handleModalConfirmation({ type, uuid, data }) {
  try {
    if (type === "checkin") {
      await checkinRepository
        .update(uuid, {
          in_house_date: data.check_in_date,
          status: "In House",
        })
        .then(() => {
          getAll();
          handlePrint();
          modalCheckIn.value = false;
        });
    }
  } catch (error) {
    console.error(error);
  }
}

function toggleModal() {
  modal.value = !modal.value;
}

function toggleFilterModal() {
  modalFilter.value = !modalFilter.value;
}

function handleSearch(query) {
  search.value = query;
  getAll(startDate.value, endDate.value, filterStatus.value.status, query);
}

watch([startDate, endDate, filterStatus], () => {
  getAll(
    startDate.value,
    endDate.value,
    filterStatus.value.status,
    search.value
  );
});

onMounted(() => {
  getAll();
});

function handlePrint() {
  nextTick(() => {
    const printContents = document.getElementById("printArea").innerHTML;
    const printWindow = window.open("", "", "height=600,width=800");
    printWindow.document
      .write(`<!DOCTYPE html><html><head><title>Cetak Resi - Deli River Hotel</title>
      <style>body{font-family:sans-serif;padding:20px;}h2{margin-bottom:10px;}p{margin:0 0 5px;}</style>
    </head><body>${printContents}</body></html>`);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  });
}
</script>

<style scoped>
.bg-primary {
  background-color: #0d6efd !important;
}

.border-bottom {
  border-bottom: 1px solid #e9ecef !important;
}

.text-start {
  text-align: left !important;
}

.fs-4 {
  font-size: 1.5rem;
}

ul {
  padding-left: 0;
}

li span:first-child {
  min-width: 100px;
  flex-shrink: 0;
}

.billing li span:first-child {
  min-width: 160px;
  flex-shrink: 0;
  font-weight: bold;
}

.billing li span:nth-child(2) {
  width: 10px;
  text-align: left;
  flex-shrink: 0;
  font-weight: bold;
}

.billing li span:last-child {
  flex: 1;
  font-weight: bold;
  word-wrap: break-word;
}

/* Style untuk extra charges */
.extra-charges {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}

.extra-charge-item {
  padding: 4px 8px;
  background-color: #f8f9fa;
  border-radius: 4px;
  border-left: 3px solid #007bff;
}

/* style untuk print resi*/
@media print {
  body * {
    visibility: hidden;
  }
  #printArea,
  #printArea * {
    visibility: visible;
  }
  #printArea {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }
  button {
    display: none !important;
  }
  .navbar,
  .footer,
  .btn {
    display: none;
  }
  .print-only {
    display: block !important;
  }
  .screen-only {
    display: none !important;
  }
}

/* Elemen hanya layar vs hanya print */
.print-only {
  display: none;
}
.screen-only {
  display: block;
}
</style>
